import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Add Credit", -1)
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Amount($)", -1)
const _hoisted_5 = { class: "form-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Description", -1)
const _hoisted_7 = {
  key: 0,
  class: "form-field"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Lease", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  type: "submit"
}, "Save", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Credit"),
  /*#__PURE__*/_createElementVNode("th", null, "Balance")
], -1)

import { onMounted, ref } from "vue";
import api from "@virgodev/bazaar/functions/api";
// const router = useRouter();
import { storeToRefs } from "pinia";
import { useStore } from "@/store";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);

const router = useRouter();
const formFields = ref({
  description: "",
  amount: "",
});
const customer_detail_page = ref("customer_detail_ess");
const leaseId = ref(null);
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const customer = ref();
const errors = ref("");

onMounted(async () => {
  if (api_settings.require_lease_with_credit) {
    customer_detail_page.value = "customer_detail_storedge";
  }
});
async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `credit/?id=${props.customerId}&facilityId=${props.facilityId}`;
  if (api_settings.require_lease_with_credit) {
    url += "&lease_id=" + leaseId.value;
  }
  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    router.push({
      name: customer_detail_page.value,
      params: {
        id: props.customerId,
        facilityId: props.facilityId,
      },
    });
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body;
    if (response.body.length) {
      customer.value = response.body[0];
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getCustomer();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: customer_detail_page.value,
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.amount) = $event)),
          type: "number",
          step: ".01",
          required: ""
        }, null, 512), [
          [_vModelText, formFields.value.amount]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.description) = $event))
        }, null, 512), [
          [_vModelText, formFields.value.description]
        ])
      ]),
      (_unref(api_settings).require_lease_with_credit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((leaseId).value = $event)),
              class: "form-select",
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.value.rentals, (rental) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: rental.id,
                  value: rental.id
                }, _toDisplayString(rental.unit.name), 9, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, leaseId.value]
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_10,
      _createVNode(_component_RouterLink, {
        to: {
        name: customer_detail_page.value,
        params: { id: __props.customerId, facilityId: __props.facilityId },
      },
        class: "btn btn-text"
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["to"])
    ], 40, _hoisted_2),
    (customer.value)
      ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(customer.value.name), 1),
            _createElementVNode("td", null, _toDisplayString(customer.value.credit), 1),
            _createElementVNode("td", null, _toDisplayString(customer.value.balance), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})